import { Component, Input } from '@angular/core';

import { AbstractViewFieldComponent } from '../base/abstract-view-field';

@Component({
  selector: 'app-form-view-wysiwyg',
  templateUrl: './view-wysiwyg.component.html',
  styleUrls: ['../view-field/form-view-field.component.scss'],
  standalone: false,
})
export class FormViewWysiwygComponent extends AbstractViewFieldComponent {
  @Input() initialValue: string | undefined;
}
